import React, { useState } from "react";
import { Spinner, Button, Intent, Checkbox } from "@blueprintjs/core";
import api from "../common/lib/api";
import Errors, { useError } from "../common/components/Errors";

export default function TermsAndConditions({ value, onChange, ...other }) {
  const [state, setState] = useState({
    status: "initial",
  });
  const { errors, setErrors, handleError } = useError();
  const errorsSnip = (
    <>
      {errors.length > 0 && (
        <Errors.Callout errors={errors} setErrors={setErrors} />
      )}
    </>
  );
  const load = async () => {
    try {
      setState({
        status: "loading",
      });
      const { data: policy } = await api.get("/privacy-policy/content");
      if (policy.url) {
        const { data } = await api.get(policy.url, {
          withCredentials: false,
        });
        setState({
          status: "ready",
          policy: data,
        });
      } else if (policy.html) {
        setState({
          status: "ready",
          policy: policy.html,
        });
      } else {
        throw new Error("Could not parse policy");
      }
      console.log(policy);
    } catch (e) {
      setState({
        status: "error",
      });
      handleError(e);
    }
  };
  if (state.status === "initial" || state.status === "error") {
    return (
      <div>
        <p>
          <Checkbox {...other} onClick={load}>
            <span className="bp3-link">Review terms and conditions</span>
          </Checkbox>
        </p>
        {errorsSnip}
      </div>
    );
  }
  if (state.status === "loading") {
    return <Spinner />;
  }
  if (state.status === "chosen") {
    if (value) {
      return (
        <div>
          <p>
            <Checkbox {...other} checked={true} onChange={load}>
              I agree
            </Checkbox>
          </p>
        </div>
      );
    }
    return (
      <div>
        <p>
          <Checkbox {...other} checked={false} onChange={load}>
            I do not accept
          </Checkbox>
        </p>
      </div>
    );
  }
  return (
    <div
      className="bp3-input"
      style={{
        height: "50vh",
        overflow: "auto",
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: state.policy }}></div>
      <p style={{ textAlign: "center" }}>
        <Button
          intent={Intent.SUCCESS}
          onClick={() => {
            onChange({ target: { value: true } });
            setState({ ...state, status: "chosen" });
          }}
        >
          I Agree
        </Button>
        <Button
          intent={Intent.DANGER}
          onClick={() => {
            onChange({ target: { value: false } });
            setState({ ...state, status: "chosen" });
          }}
        >
          I Disagree
        </Button>
      </p>
    </div>
  );
}
